import React, { useState, useEffect } from "react"
import PropTypes from "prop-types"
import styles from "./SignUpApplyWrapper.module.scss"
import SignUpApplyContainer from "./SignUpApplyWrapper"
import SignUpApplyStep1Form from "../../forms/SignUpApplyForms/SignUpApplyStep1Form"
import { useLocation } from "react-router-dom"

const SignUpApplyStep1Container = ({
  history,
  handleNext,
  handleBack,
  initialValues,
  stepBackClicked,
}) => {
  const [isFormValid, setIsFormValid] = useState(false)
  const location = useLocation()
  const isTestMode =
    new URLSearchParams(location.search).get("test-data") === "1"

  const handleFormSubmit = (values) => {
    handleNext(values)
  }

  const handleNextClick = (e) => {
    e.preventDefault()
    document.querySelector("button[type='submit']").click()
  }

  const testData = isTestMode
    ? {
        firstName: "John",
        lastName: "Doe",
        email: "john.doe@example.com",
        phoneNumber: "+1 (555) 123-4567",
        whichBusinessType: "company_seeker",
        bestDescribes: "emerging",
      }
    : null

  return (
    <SignUpApplyContainer
      title="Salesforce Membership Application"
      onBack={handleBack}
      onNext={handleNextClick}
      isButtonSubmit={false}
      withBackBtn={false}
      isNextDisabled={!isFormValid}
    >
      <SignUpApplyStep1Form
        onSubmit={handleFormSubmit}
        onValidityChange={setIsFormValid}
        initialValues={testData || initialValues}
      />
    </SignUpApplyContainer>
  )
}

SignUpApplyStep1Container.propTypes = {
  history: PropTypes.object,
  handleNext: PropTypes.func,
  handleBack: PropTypes.func,
  initialValues: PropTypes.object,
  stepBackClicked: PropTypes.bool,
}

export default SignUpApplyStep1Container
